import { render, staticRenderFns } from "./SalaryAdvances.vue?vue&type=template&id=15edd27c&scoped=true"
import script from "./SalaryAdvances.vue?vue&type=script&lang=js"
export * from "./SalaryAdvances.vue?vue&type=script&lang=js"
import style0 from "./SalaryAdvances.vue?vue&type=style&index=0&id=15edd27c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15edd27c",
  null
  
)

export default component.exports